module.exports = __webpack_public_path__ + "static/img/ket-renewal-mobile-main-01@m.b4f4118.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/ket-renewal/ket-renewal-mobile-main-01@m.png
// module id = m27r
// module chunks = 0